/* eslint-disable consistent-return */
/* eslint-disable comma-dangle */
/* eslint-disable arrow-parens */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import 'react-accessible-accordion/dist/fancy-example.css';

import {
  Container,
  // ViewBottomFaq,
} from './styles';

import FAQ from '~/components/Faq';

export default function Faq() {
  window.scrollTo(0, 0);
  return (
    <Container>
      <h1>Perguntas e Respostas Frequentes</h1>
      <div>
        <FAQ />
      </div>
      {/* <p
          style={{
            color: '#fff',
            textAlign: 'center',
            marginTop: 20,
            fontSize: 14,
            marginBottom: '2.5%',
            width: '90%',
          }}
        >
          Se você ainda tiver alguma dùvida, nos envie um e-mail que respondemos
          pra você.
        </p>
        <ViewBottomFaq>
          <button type="submit">ENVIAR E-MAIL</button>
        </ViewBottomFaq> */}
    </Container>
  );
}
